import { SUBMIT_ACTIONS } from "static/constants";

export const reportDetailAction = {
  loadReports: (state, action) => {
    let newReports = [];
    newReports = [...newReports, action.payload];
    state.reports = newReports;
  },
  selectedReport: (state, action) => {
    const { id, isLegacyReport, reportDetail } = action.payload;

    state.reportId = id;
    state.isLegacyReport = isLegacyReport;
    state.reportDetail = reportDetail;
    state.autoScrollPageNumber = reportDetail?.auto_scroll_page_number;
    state.information = reportDetail?.patient?.information;
    state.isNonBillable = reportDetail?.explicit_non_billable || false;
  },
  toggleDrawer: (state, action) => {
    const updatePayload = action.payload;
    const currentUserId = localStorage.getItem("userId");

    localStorage.setItem(`isDrawerOpen:${currentUserId}`, updatePayload);
    state.openDrawer = updatePayload;
  },
  toggleNurseFlag: (state, action) => {
    state.nurseFlag = action.payload;
  },
  toggleClinicEsig: (state, action) => {
    state.clinicNotesEsig = action.payload;
  },

  changeExpansion: (state, action) => {
    const { type, value } = action.payload;
    switch (type) {
      case "patientNotes": {
        state.patientNotesExpanded = value;
        break;
      }
      case "clinicNotes": {
        state.clinicNotesExpanded = value;
        break;
      }
      case "tasks": {
        state.tasksExpanded = value;
        break;
      }
      case "ehrNotes": {
        state.ehrNoteExpanded = value;
        break;
      }
      default:
    }
  },

  toggleSubmitting: (state, action) => {
    const { type, value, submitAction } = action.payload;

    switch (type) {
      case "clinicNotes": {
        state.clinicNotesTouched = value;
        if (submitAction === SUBMIT_ACTIONS.SAVE_AND_PROCESS) {
          state.clinicNoteSubmittingAndProcessing = value;
        } else if (submitAction === SUBMIT_ACTIONS.SAVE_SIGN_AND_PROCESS) {
          state.clinicNoteSubmittingAndSigningAndProcessing = value;
        } else if (submitAction === SUBMIT_ACTIONS.SAVE_SIGN_AND_UNPROCESS) {
          state.clinicNoteSubmittingAndSigningAndUnProcessing = value;
        } else {
          state.clinicNoteSubmitting = value;
        }
        break;
      }
      case "clinicMrn": {
        state.clinicMrnSubmitting = value;
        state.clinicMrnTouched = value;
        break;
      }
      case "patientNotes": {
        state.patientNotesSubmitting = value;
        state.patientNotesFocused = value;
        break;
      }
      case "reportNotes": {
        if (submitAction === SUBMIT_ACTIONS.ARCHIVE) {
          state.isReportArchiving = value;
        } else if (submitAction === SUBMIT_ACTIONS.SAVE_AND_PROCESS) {
          state.isReportNoteSubmittingAndProcessing = value;
        } else {
          state.isReportNoteSubmitting = value;
        }
        break;
      }
      case "billing": {
        state.isBillingDateSubmitting = value;
        break;
      }
      case "reportTasks": {
        state.taskSubmitting = value;
        break;
      }
      case "ehrNotes": {
        state.ehrNoteSubmitting = value;
        break;
      }
      case "providerNotes": {
        state.providerNotesTouched = value;
        if (submitAction === SUBMIT_ACTIONS.SAVE_AND_PROCESS) {
          state.providerNoteSubmittingAndProcessing = value;
        } else if (submitAction === SUBMIT_ACTIONS.SAVE_SIGN_AND_PROCESS) {
          state.providerNoteSubmittingAndSigningAndProcessing = value;
        } else if (submitAction === SUBMIT_ACTIONS.SAVE_SIGN_AND_UNPROCESS) {
          state.providerNoteSubmittingAndSigningAndUnProcessing = value;
        } else {
          state.providerNoteSubmitting = value;
        }
        break;
      }
      default:
    }
  },

  toggleAlertStatus: (state, action) => {
    state.alertStatus = action.payload;
  },

  toggleAnticoagStatus: (state, action) => {
    state.anticoagStatus = action.payload;
  },

  toggleAnticoagInformation: (state, action) => {
    state.anticoagInformation = action.payload;
  },

  toggleAttentionStatus: (state, action) => {
    state.attentionStatus = action.payload;
  },

  toggleIsUpdatingReportNotes: (state, action) => {
    state.isUpdatingReportNotes = action.payload;
  },

  setPdfPageRefs: (state, action) => {
    state.pdfPageRefs = action.payload;
  },

  toggleUndo: (state, action) => {
    state.undo = action.payload;
  },

  toggleReportAlertBanner: (state, action) => {
    state.alertBanner = action.payload;
  },

  toggleHasAlertBanner: (state, action) => {
    state.hasAlertBanner = action.payload;
  },

  setReportAccountDetail: (state, action) => {
    state.reportAccountDetail = action.payload;
  },

  setReportCurrentTab: (state, action) => {
    state.reportCurrentTab = action.payload;
  },

  setAutoScrollPageNumber: (state, action) => {
    state.autoScrollPageNumber = action.payload;
  },

  setMaximumAlertPriority: (state, action) => {
    state.maximumAlertPriority = action.payload;
  },

  setAlertNotificationConfigs: (state, action) => {
    state.alertNotificationConfigs = action.payload;
  },

  setInvalidBillingDateResponse: (state, action) => {
    state.invalidBillingDateResponse = action.payload;
  },
  toggleNonBillable: (state, action) => {
    state.isNonBillable = action.payload;
  },

  setCrossFacilityReport: (state, action) => {
    state.isCrossFacilityReport = action.payload;
  },
};
